import { createAsyncThunk } from "@reduxjs/toolkit"

import apiClient from "src/apiClient"

// `handlesOwnErrors`: the screen that calls this renders the refusal itself, against the field it
// is about. Without it the interceptor adds axios's own "Request failed with status code 400"
// beside it — in English, about nothing the player did — so the same refusal reads twice and the
// louder half says less. The caller still gets the rejection. (Same reason `joinLobby` carries it;
// it was the only one that did.)
export const thunk = createAsyncThunk("user/resetPassword", async ({ uid, token, password }, { rejectWithValue }) => {
  try {
    await apiClient.post("reset-password/", { uid, token, password }, { handlesOwnErrors: true })
    return null
  } catch (error) {
    return rejectWithValue(error.response?.data)
  }
})

export const onSucceed = (s) => s

const thunkObject = { thunk, onSucceed }
export default thunkObject
